module.exports = __webpack_public_path__ + "img/waf.05c9e4e.svg";